
import { useState, useCallback, useEffect } from 'react';
import {
    CircularProgress,
    Grid,
    TextField,
    Autocomplete,
    Button,
    FormControlLabel,
    Switch,
    MenuItem
} from '@mui/material';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import getDayjs from "../../../../context/DateInstance";
import { useAxios } from '../../../../context/AxiosHookContext';
import { useAuth } from "../../../../context/AuthContext";
import { useNotification } from "../../../../context/NotificationContext";
import { communicationTypes,communicationsExternalTypes } from '../../../../utils/lists';
import { InputValidationMessage } from '../../../inputs/CustomField';
import UploadFilesDrive from '../../../files/UploadFiles';

const initialCommunicationState = {
    type: null,
    noRequest: "",
    requestDate: null,
    requester: null,
    subject: "",
    tipoDocumento: ""
};


export default function CommunicationsModalForm({ onClose, communication = {} }) {
    const { currentUser } = useAuth()

    const axios = useAxios();
    const [selectedValuesToEdit, selectValuesToEdit] = useState(
        {
            ...communication,
            requester: {
                _id: currentUser._id,
                displayName: currentUser.displayName
            }
        });
    const [filterName, setFilterName] = useState("");
    const [filterNameUser, setFilterNameUser] = useState("");
    const [filterNameOrganization, setFilterNameOrganization] = useState("");
    const [openOrganizationList, setOpenOrganizationList] = useState(false);
    const [openTypesList, setOpenTypeList] = useState(false);
    const [openOrganizationListUser, setOpenOrganizationListUser] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loadingOrg, setLoadingOrg] = useState(false);
    const [organizationList, setorganizationList] = useState([]);
    const { showSnackbar } = useNotification();
    const [userList, setUserList] = useState([]);
    const [userListInternal,setUserListInternal] = useState([]);
    const [loading, setLoading] = useState(false);
    const [commType, setCommType] = useState([]);
    const [personalityName, setFilterNamePersonality] = useState("");
    const [personalitiesList, setPersonalitiesList] = useState([]);
    const [openReceiverList, setOpenReceiverList] = useState(false);
    const [adjuntos, setAdjuntos] = useState(communication?.files?.length > 0 ? true : false)


    const onChangeValues = async (e) => {

        if (e.target.name === "type") {
            const noRequest = await getNoRequest(e.target.value)
            selectValuesToEdit({ ...selectedValuesToEdit, noRequest: noRequest, [e.target.name]: e.target.value })
        } else {
            selectValuesToEdit({ ...selectedValuesToEdit, [e.target.name]: e.target.value })
        }
    }


    const USERS_API = `/users?page=1&limit=10&role=Communications&displayName=${filterNameUser}`


    const getOrgs = useCallback(async () => {
        try {
            setUserList([])
            setLoading(true);
            const { data } = await axios.get(USERS_API);
            setUserList(data.data.list);

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }, [axios, USERS_API, setUserList, setLoading, filterName]);

    const getUserInternal = useCallback(async () => {
        try {
            const { data } = await axios.get(`/users?page=1&limit=1000000&signatureCommunication=true`);
            setUserListInternal(data.data.list);

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }, [axios, USERS_API, setUserListInternal]);

    const saveCommunication = async () => {
        try {

            let error = false
            Object.keys(initialCommunicationState).forEach(key => {
                if (!selectedValuesToEdit[key]) {
                    error = true;
                }
            })

            if (error) {
                return
            }

            setIsSubmitting(true)
            const body = { ...selectedValuesToEdit }

            if (body._id) {

                await axios.put(`/communications/update/${body._id}`, body);

            } else {

                await axios.post(`/communications/create`, body);
                selectValuesToEdit({})
            }

            showSnackbar({ severity: "success", title: "Guardado", message: "Se ha guardado la comunicación correctamente." });
            onClose();
        } catch (error) {

            const message = error?.response?.data?.message || "Ha ocurrido un error al guardar."
            showSnackbar({ severity: "error", title: "Error", message });

        } finally {
            setIsSubmitting(false);
        }
    }

    const getNoRequest = async (type) => {
        try {

            if (!type) {
                return
            }
            const { data } = await axios.post(`/communications/newNoRequest`, type);
            return data.data

        } catch (error) {
            const message = error?.response?.data?.message || "Ha ocurrido un error al buscar el numero de solicitud."
            showSnackbar({ severity: "error", title: "Error", message });
        }
    }


    const getOrganizations = useCallback(async () => {
        try {
            const organizationApi = `/personalities/organizations?page=${1}&limit=30${filterNameOrganization ? `&nombre=${filterNameOrganization}` : ''}`
            setorganizationList([]);
            setPersonalitiesList([]);
            setLoadingOrg(true);
            const { data } = await axios.get(organizationApi);
            setorganizationList(data?.data?.list);

        } catch (error) {
            console.log(error);
        } finally {
            setLoadingOrg(false);
        }
    }, [axios, setLoadingOrg, filterNameOrganization, setPersonalitiesList]);

    const loadCommunicationTypesByPermission = () => {

        const incluseExternal = currentUser?.role?.includes("Communications-external")

        if (!incluseExternal) {
            setCommType(communicationTypes.filter(item => item.key !== "EXT"))
        } else {
            setCommType(communicationTypes)
        }

    }

    const getPersonalities = useCallback(async (_id) => {
        try {
            if (selectedValuesToEdit?.destinationInstitution?._id || _id) {

                const institucionId = selectedValuesToEdit?.destinationInstitution?._id || _id
                const api = `/personalities?page=1&limit=10${personalityName ? `&fullName=${personalityName}` : ''}${institucionId ? `&institucionId=${institucionId}` : ''}`

                setPersonalitiesList([])
                setLoading(true);
                const { data } = await axios.get(api);
                setPersonalitiesList(data?.data?.list);
            }

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }, [axios, personalityName, selectedValuesToEdit]);

    useEffect(() => {
        getOrganizations()
    }, [filterName])

    useEffect(() => {
        getPersonalities();
    }, [personalityName])

    useEffect(() => {
        getOrgs()
    }, [getOrgs, filterNameUser])

    useEffect(() => {
        getOrganizations()
    }, [getOrganizations, filterNameOrganization])

    useEffect(() => {
        if (!selectedValuesToEdit.requestDate) {
            selectValuesToEdit({
                ...selectedValuesToEdit,
                requestDate: getDayjs()
            })
        }
    }, [selectedValuesToEdit])


    useEffect(() => {
        getUserInternal()
        loadCommunicationTypesByPermission()
    }, [])


    return (

        <Grid container spacing={2} mb={2}>

            <Grid container item xs={12} spacing={2}>

                <Grid item xs={12} md={6} mt={1}>

                    <Autocomplete
                        size="small"
                        fullWidth
                        id="support_assigned"
                        open={openTypesList}
                        onOpen={() => {
                            setOpenTypeList(true);
                        }}
                        onClose={() => {
                            setOpenTypeList(false);
                        }}
                        isOptionEqualToValue={(option, value) => option.description === value.description}
                        getOptionLabel={(option) =>
                            option.description
                        }
                        options={commType}
                        defaultValue={{ _id: selectedValuesToEdit?.type?._id || "", description: selectedValuesToEdit?.type?.description || "" }}
                        onChange={(_e, value) => {
                            if (!value) {
                                setFilterNameUser("")
                                onChangeValues({ target: { name: "type", value: null } })
                                return
                            }
                            onChangeValues({ target: { name: "type", value } })
                        }}
                        renderInput={(params) => (
                            <TextField
                                fullWidth
                                size="small"
                                {...params}
                                label="Tipo"
                                onChange={(e) => {
                                    setFilterNameUser(e.target.value)
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />
                    {!selectedValuesToEdit?.type?._id ? <InputValidationMessage message={"Es requerido este campo."} /> : ''}
                </Grid>

                <Grid item xs={12} md={6} mt={1}>
                    <TextField size="small" label="No. de solicitud" name="noRequest" value={selectedValuesToEdit?.noRequest || ""} fullWidth disabled />
                </Grid>

                <Grid item xs={12} md={6} mt={1}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} fullWidth>
                        <DateTimePicker name="requestDate" label="Fecha solicitud" fullWidth
                            value={selectedValuesToEdit?.requestDate ? getDayjs(selectedValuesToEdit?.requestDate) : getDayjs()}
                            onChange={(value) => onChangeValues({ target: { name: "requestDate", value: value } })}
                            sx={{
                                width: "100%",
                                '& .MuiInputBase-input': {
                                    fontSize: '15px', // Ajusta el tamaño del texto
                                    padding: '8.5px 32px 8.5px 14px',
                                }
                            }}
                        />
                    </LocalizationProvider>
                </Grid>

                <Grid item xs={12} md={6} mt={1}>
                    <TextField
                        size="small"
                        label="Tipo de Documento"
                        name="tipoDocumento"
                        value={selectedValuesToEdit?.tipoDocumento || ""}
                        fullWidth
                        onChange={onChangeValues}
                        select
                    >
                        {communicationsExternalTypes.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>

                    {!selectedValuesToEdit?.tipoDocumento ? <InputValidationMessage message={"Es requerido este campo."} /> : ''}
                  
                </Grid>


                <Grid item xs={12} md={6} mt={1}>
                    <Autocomplete
                        size="small"
                        fullWidth
                        id="support_assigned"
                        open={openOrganizationListUser}
                        onOpen={() => {
                            setOpenOrganizationListUser(true);
                        }}
                        onClose={() => {
                            setOpenOrganizationListUser(false);
                        }}
                        isOptionEqualToValue={(option, value) => option.displayName === value.displayName}
                        getOptionLabel={(option) =>
                            option.displayName
                        }
                        options={[{
                            _id: currentUser._id,
                            displayName: currentUser.displayName
                        }]}
                        defaultValue={{ _id: selectedValuesToEdit?.requester?._id || "", displayName: selectedValuesToEdit?.requester?.displayName || "" }}
                        onChange={(_e, value) => {
                            if (!value) {
                                setFilterNameUser("")
                                onChangeValues({ target: { name: "requester", value: null } })
                                return
                            }
                            onChangeValues({ target: { name: "requester", value: { _id: value._id, displayName: value.displayName } } })
                        }}
                        renderInput={(params) => (
                            <TextField
                                fullWidth
                                size="small"
                                {...params}
                                label="Solicitante"
                                onChange={(e) => {
                                    setFilterNameUser(e.target.value)
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />
                    {!selectedValuesToEdit?.requester?._id ? <InputValidationMessage message={"Es requerido este campo."} /> : ''}
                </Grid>


                {selectedValuesToEdit?.type?._id === 1 &&

                    <Grid item xs={12} md={6} mt={1}>
                        <Autocomplete
                            size="small"
                            fullWidth
                            id="support_assigned"
                            open={openOrganizationList}
                            onOpen={() => {
                                setOpenOrganizationList(true);
                            }}
                            onClose={() => {
                                setOpenOrganizationList(false);
                            }}
                            isOptionEqualToValue={(option, value) => option.nombre === value.nombre}
                            getOptionLabel={(option) =>
                                option.nombre
                            }
                            options={organizationList}
                            defaultValue={{ _id: selectedValuesToEdit?.destinationInstitution?._id || "", nombre: selectedValuesToEdit?.destinationInstitution?.nombre || "" }}
                            onChange={(_e, value) => {
                                if (!value) {
                                    setFilterNameOrganization("")
                                    onChangeValues({ target: { name: "destinationInstitution", value: null } })
                                    setPersonalitiesList([]);
                                    return
                                }
                                onChangeValues({ target: { name: "destinationInstitution", value: { _id: value._id, nombre: value.nombre } } })
                                getPersonalities(value._id);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    fullWidth
                                    size="small"
                                    {...params}
                                    label="Institución destinatario"
                                    onChange={(e) => {
                                        setFilterNameOrganization(e.target.value)
                                    }}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {loadingOrg ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                        />
                        {!selectedValuesToEdit?.destinationInstitution?._id ? <InputValidationMessage message={"Es requerido este campo."} /> : ''}
                    </Grid>
                }

                {
                    selectedValuesToEdit?.type?._id === 2 &&

                    <Grid item xs={12} md={6} mt={1}>
                        <Autocomplete
                            size="small"
                            fullWidth
                            id="support_assigned"
                            open={openReceiverList}
                            onOpen={() => {
                                setOpenReceiverList(true);
                            }}
                            onClose={() => {
                                setOpenReceiverList(false);
                            }}
                            isOptionEqualToValue={(option, value) => option.displayName === value.displayName}
                            getOptionLabel={(option) =>
                                option.displayName
                            }
                            options={userListInternal}
                            defaultValue={{ _id: selectedValuesToEdit?.receiver?._id || "", displayName: selectedValuesToEdit?.receiver?.displayName || "" }}
                            onChange={(_e, value) => {
                                if (!value) {
                                    setFilterNameUser("")
                                    onChangeValues({ target: { name: "receiver", value: null } })
                                    return
                                }
                                onChangeValues({ target: { name: "receiver", value: { _id: value._id, displayName: value.displayName } } })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    fullWidth
                                    size="small"
                                    {...params}
                                    label="Destinatario interno"
                                    onChange={(e) => {
                                        setFilterNameUser(e.target.value)
                                    }}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                        />
                        {!selectedValuesToEdit?.receiver?._id ? <InputValidationMessage message={"Es requerido este campo."} /> : ''}
                    </Grid>
                }

                {
                    selectedValuesToEdit?.type?._id === 1 &&

                    <Grid item xs={12} md={6} mt={1}>
                        <Autocomplete
                            disabled={!selectedValuesToEdit?.destinationInstitution?._id}
                            size="small"
                            fullWidth
                            id="support_assigned"
                            open={openReceiverList}
                            onOpen={() => {
                                setOpenReceiverList(true);
                            }}
                            onClose={() => {
                                setOpenReceiverList(false);
                            }}
                            isOptionEqualToValue={(option, value) => option.fullName === value.displayName}
                            getOptionLabel={(option) =>
                                option.fullName
                            }
                            options={personalitiesList}
                            defaultValue={{ _id: selectedValuesToEdit?.receiver?._id || "", fullName: selectedValuesToEdit?.receiver?.displayName || "" }}
                            onChange={(_e, value) => {
                                if (!value) {
                                    setFilterNamePersonality("")
                                    onChangeValues({ target: { name: "receiver", value: null } })
                                    return
                                }
                                onChangeValues({ target: { name: "receiver", value: { _id: value._id, displayName: value.fullName } } })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    fullWidth
                                    size="small"
                                    {...params}
                                    label="Destinatario externo"
                                    onChange={(e) => {
                                        setFilterNamePersonality(e.target.value)
                                    }}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                        />
                        {!selectedValuesToEdit?.receiver?._id ? <InputValidationMessage message={"Es requerido este campo."} /> : ''}
                    </Grid>

                }

                <Grid item xs={12} md={6} mt={1}>
                    <TextField size="small" value={selectedValuesToEdit?.subject || ""} label="Asunto" name="subject" multiline rows={4} fullWidth onChange={onChangeValues} />
                    {!selectedValuesToEdit?.subject ? <InputValidationMessage message={"Es requerido este campo."} /> : ''}
                </Grid>

            </Grid>

            <Grid item xs={12} >

                <FormControlLabel control={<Switch checked={adjuntos} onChange={(e) => setAdjuntos(e.target.checked)} />} label="Adjuntos" />

                {
                    adjuntos &&

                    <>
                        <Grid item xs={12} md={6} mt={1}>
                            <TextField size="small" value={selectedValuesToEdit?.filesComment || ""} label="Comentario de adjuntos" name="filesComment" multiline rows={3} fullWidth onChange={onChangeValues} />
                        </Grid>

                        <UploadFilesDrive
                            files={selectedValuesToEdit?.files || []}
                            onLoadFile={
                                (files) => {
                                    onChangeValues({ target: { name: "files", value: files } })
                                    axios.put(`/communications/update/${selectedValuesToEdit?._id}`, { ...selectedValuesToEdit, files });
                                }} />
                    </>
                }

            </Grid>

            <Grid item sm={12} textAlign={"right"} mt={3}>
                <Button
                    variant="outlined"
                    onClick={() => {
                        onClose();
                    }}
                >
                    cancelar
                </Button>

                <Button sx={{ marginLeft: 2 }}
                    variant="contained"
                    type="submit"
                    onClick={saveCommunication}
                >
                    {isSubmitting && <CircularProgress size={"15px"} sx={{ color: "white", marginRight: "6px" }} />}
                    {isSubmitting ? 'Guardando' : 'Guardar'}
                </Button>
            </Grid>
        </Grid>
    )
}